// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"45b5f75a","162":"c48a8225","185":"6179a532","240":"340e5c1f","274":"f5db9c77","453":"e9489166","508":"4e459606","833":"1f9172db"}[chunkId] + ".chunk.js";
};